import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import "./style.scss";

const AdAgreement = inject("mainStore")(
    observer(({ mainStore }) => {
        const { thirdParam } = useParams();

        const [data, setData] = useState(null);

        useEffect(() => {
            const fetchData = async () => {
                const resp = await mainStore.getByUrl("/app_rispromo_supply/vend_info", { vendorId: thirdParam });
                if (resp && resp.data) {
                    setData(resp.data);
                } else {
                    mainStore.setMainStore("isNotFound", true);
                }
            };

            fetchData();
        }, []);

        return (
            data && (
                <div className="ad-agreement">
                    <h2>Согласие на получение рекламных сообщений</h2>
                    <p>
                        Я даю свое согласие {data.vendorInfo?.fullOpf} (далее - Оператор, ИНН: {data.vendorInfo?.INN}, адрес: {data.vendorInfo?.address}) на:
                    </p>
                    <p>
                        показ и направление информационных сообщений, рекламных и рекламно-информационных предложений (как персонализированных, так и не персонализированных) об акциях, подарках, предложениях, новостях, подборках Оператора,
                        реализуемых следующими способами (совокупно или по отдельности):
                    </p>
                    <ul>
                        <li>осредством смс-сообщений и сообщений в мессенджерах (Telegram, WhatsApp и проч.) и в социальных сетях (VK и проч.) на предоставленный мной номер телефона;</li>
                        <li>посредством прямого контакта (звонки) по предоставленному мной номеру телефона;</li>
                        <li>посредством сообщений на адрес электронной почты;</li>
                        <li>посредством пуш-уведомлений.</li>
                    </ul>
                    <p>
                        Настоящее согласие дано с целью оперативного получения новостей о специальных предложениях и рекламных акциях, системе скидок, бонусов и различного рода рекламных мероприятиях, направленных на продвижение товаров и услуг,
                        реализуемых Оператором. В этой связи я предоставляю Оператору свое согласие на обработку в документальной и/или электронной форме (автоматизированную, неавтоматизированную и смешанную обработку), включая сбор, запись,
                        систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, распространение, предоставление доступа, передачу третьим лицам, обезличивание, блокирование, удаление, уничтожение, следующих
                        персональных данных:
                    </p>
                    <ul>
                        <li>фамилия, имя, отчество;</li>
                        <li>адрес электронной почты;</li>
                        <li>контактный телефон.</li>
                    </ul>
                    <p>
                        Я подтверждаю, что владею информацией о том, что в любой момент в течение всего срока действия настоящего согласия, я вправе отозвать настоящее согласие и отказаться от получения сообщений рекламного характера, пройдя по
                        соответствующей ссылке в получаемых от Оператора электронных письмах или направив уведомление об отказе от получения сообщений рекламного характера по адресу, указанному в настоящем Согласии. В этом случае Оператор прекращает
                        обработку персональных данных, а персональные данные подлежат уничтожению, если отсутствуют иные правовые основания для обработки, установленные законодательством Российской Федерации. Обработка персональных данных
                        прекращается по достижении цели обработки персональных данных, по получении отзыва согласия на получение новостной и рекламной рассылки и/или на обработку персональных данных или исключения Оператора из Единого
                        государственного реестра юридических лиц.
                    </p>
                </div>
            )
        );
    }),
);

export default AdAgreement;
